import React, { useState } from 'react'

const CATEGORIES = ['Todos', 'Branding', 'Social Media', 'Performance', 'Web', 'Outros']

const CASES = [
  {
    client: 'Campo Real',
    category: 'Branding',
    title: 'Identidade Visual Campo Real',
    desc: 'Redesign completo da identidade visual com posicionamento estratégico para o mercado educacional.',
    result: '+45% reconhecimento de marca | +30% engajamento',
    tags: ['branding', 'identidade', 'educação'],
    initial: 'C',
  },
  {
    client: 'Cresol',
    category: 'Social Media',
    title: 'Gestão de Redes Sociais Cresol',
    desc: 'Estratégia de conteúdo humanizado para cooperativa de crédito com foco em engajamento e confiança.',
    result: '+180% engajamento | +90% alcance orgânico',
    tags: ['social', 'conteúdo', 'financeiro'],
    initial: 'C',
  },
  {
    client: 'Bacana Motors',
    category: 'Performance',
    title: 'Campanha de Tráfego Bacana Motors',
    desc: 'Campanhas de mídia paga no Google e Meta com segmentação comportamental avançada.',
    result: '3.2x ROI | -40% CPL | +120% conversões',
    tags: ['tráfego', 'performance', 'automotivo'],
    initial: 'B',
  },
  {
    client: 'OL Construtora',
    category: 'Web',
    title: 'Site Institucional OL Construtora',
    desc: 'Website responsivo com foco em conversão, SEO e experiência do usuário para construtora.',
    result: '+200% leads qualificados | Top 3 Google',
    tags: ['web', 'site', 'construção'],
    initial: 'O',
  },
  {
    client: 'Nadi Modas',
    category: 'Branding',
    title: 'Branding Nadi Modas',
    desc: 'Identidade visual e posicionamento de marca para loja de moda feminina premium.',
    result: '+60% ticket médio | Expansão para 2 lojas',
    tags: ['branding', 'moda', 'varejo'],
    initial: 'N',
  },
  {
    client: 'Macias & Cruz Advogados',
    category: 'Performance',
    title: 'Inbound Marketing Macias & Cruz',
    desc: 'Estratégia de inbound marketing e automação para escritório de advocacia.',
    result: '+150% leads qualificados | -50% custo por cliente',
    tags: ['inbound', 'jurídico', 'automação'],
    initial: 'M',
  },
]

function PortfolioContent() {
  const [filter, setFilter] = useState('Todos')
  const filtered = filter === 'Todos' ? CASES : CASES.filter((c) => c.category === filter)

  return (
    <>
      <section className='dorac-grid-bg pb-16 pt-32'>
        <div className='container mx-auto max-w-3xl px-4 text-center'>
          <span className='mb-3 block text-xs font-bold uppercase tracking-widest text-dorac-purple'>
            Nossos trabalhos
          </span>
          <h1 className='section-title mb-6'>Cases e resultados reais</h1>
          <p className='text-base leading-relaxed text-dorac-ink/60 md:text-lg'>
            Projetos que transformaram marcas, geraram crescimento e provaram que marketing humanizado com ciência do
            comportamento entrega resultado mensurável.
          </p>
        </div>
      </section>

      <section className='bg-white py-16'>
        <div className='container mx-auto px-4'>
          <div className='mb-12 flex flex-wrap justify-center gap-2'>
            {CATEGORIES.map((cat) => (
              <button
                key={cat}
                onClick={() => setFilter(cat)}
                className='rounded-full px-4 py-2 text-sm font-semibold transition-all duration-150'
                style={
                  filter === cat
                    ? { backgroundColor: '#491C47', color: '#fff' }
                    : { backgroundColor: '#FBFCFD', color: '#5F636F', border: '1px solid #D5D7DE' }
                }
              >
                {cat}
              </button>
            ))}
          </div>

          <div className='grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3'>
            {filtered.map((c) => (
              <div key={c.title} className='card-dorac flex flex-col'>
                <div className='mb-4 flex items-center gap-3'>
                  <div className='flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full bg-dorac-purple font-bold text-white'>
                    {c.initial}
                  </div>
                  <div>
                    <div className='text-xs font-bold uppercase tracking-wide text-dorac-purple'>{c.category}</div>
                    <div className='text-xs text-dorac-ink/50'>{c.client}</div>
                  </div>
                </div>
                <h3 className='mb-2 text-lg font-bold text-dorac-ink'>{c.title}</h3>
                <p className='mb-4 flex-1 text-sm leading-relaxed text-dorac-ink/60'>{c.desc}</p>
                <p className='mb-4 text-xs font-semibold text-dorac-purple'>📊 {c.result}</p>
                <div className='flex flex-wrap gap-2'>
                  {c.tags.map((tag) => (
                    <span key={tag} className='rounded-full bg-dorac-purple/10 px-2 py-1 text-xs text-dorac-purple'>
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className='dorac-grid-bg py-24'>
        <div className='container mx-auto max-w-2xl px-4 text-center'>
          <h2 className='section-title mb-6'>Quer ver o seu projeto aqui?</h2>
          <p className='section-subtitle mx-auto mb-8'>
            Vamos construir juntos o próximo case de sucesso da sua marca.
          </p>
          <a
            href='https://api.whatsapp.com/send?phone=554396659096&text=Ol%C3%A1%2C%20vim%20pelo%20site%20e%20quero%20iniciar%20um%20projeto%20com%20a%20Dorac!'
            target='_blank'
            rel='noopener noreferrer'
            className='btn-dorac px-8 py-4'
          >
            Iniciar projeto
          </a>
        </div>
      </section>
    </>
  )
}

export default PortfolioContent
